import React, { useRef } from 'react';

import { generalMessages } from '../../../translates/generalMessages';
import { useIntlReexport } from '../../hooks/useIntlReexport';
import { DIALOGS_PORTAL_ID } from '../modal/DialogsPortal';
import { Button, ButtonVariant } from '@ael/shared-components-library';
import * as ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';

import './OverlayConfirmation.scss';

export interface OverlayConfirmationProps {
  header: string;
  text: string;
  buttonLabel: string;
  cancelButtonLabel?: string;
  buttonColor?: ButtonVariant;
  onClick: () => void;
  onCancel: () => void;
}

export const OverlayConfirmation: React.FC<OverlayConfirmationProps> = ({
  header,
  text,
  buttonLabel,
  buttonColor = ButtonVariant.DANGER,
  cancelButtonLabel,
  onCancel,
  onClick,
}) => {
  const dialogElement = document.getElementById(DIALOGS_PORTAL_ID);
  const { formatMessage } = useIntlReexport();
  const overlayRef = useRef(null);

  return dialogElement
    ? ReactDOM.createPortal(
        <CSSTransition nodeRef={overlayRef} classNames="fade" timeout={333} appear={true} in={true}>
          <div ref={overlayRef} className="overlay-confirmation-overlay">
            <div className="overlay-confirmation">
              <div className="overlay-confirmation__header">{header}</div>
              <div className="overlay-confirmation__content">{text}</div>
              <div className="overlay-confirmation__footer">
                <Button variant={ButtonVariant.TEXT} onClick={onCancel}>
                  {cancelButtonLabel ?? formatMessage(generalMessages.cancel)}
                </Button>
                <Button variant={buttonColor} onClick={onClick}>
                  {buttonLabel}
                </Button>
              </div>
            </div>
          </div>
        </CSSTransition>,
        dialogElement
      )
    : null;
};
